module.exports = __webpack_public_path__ + "static/media/img_9.2a215dc5.png";